import { Molecule, wrap } from 'AppReact';
import { Mr2 } from 'wrappers';
import styled from 'styled-components';
import { Text, Icon, ProfileImage, Initials } from 'atoms';
import { CheckboxSvg } from 'components/icons';
import { getInitials } from 'utils/getInitials';

const template = styled.div`
  color: ${window?.settings?.secondary_color ?? '#04333b'};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  padding: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    font-weight: 600;
  }
`

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: wrap(Icon, Mr2),
      name: 'Checkbox',
      renderIf: ({ isSingleSelect }) => !isSingleSelect,
      displayValue: ({ isSelected }) => CheckboxSvg({ checked: isSelected }),
    },
    {
      component: wrap(ProfileImage, Mr2),
      name: 'Icon',
      renderIf: ({ icon }) => !!icon,
      displayValue: ({ icon }) => icon,
      displayState: ({ }) => ({ size: 22 })
    },
    {
      component: wrap(Initials, Mr2),
      name: 'Icon',
      renderIf: ({ icon }) => !icon,
      displayValue: ({ name }) => getInitials(name),
      displayState: ({ }) => ({ size: 22 })
    },
    {
      component: Text,
      name: 'Name',
      displayValue: ({ name }) => name
    }
  ]
})